{
    "ai_modal_title_1": "Improve your text with AI",
    "ai_modal_title_2": "Generate new text using AI",
    "ai_description": "Use AI content generation tools to improve your texts.",
    "ai_learn_more": "Learn more",
    "ai_copy_text": "Copy text",
    "ai_describe_your_text": "Describe what your text should be about",
    "ai_describe_your_text_example": "Example: a short description for an online shop that sells handmade soap",
    "ai_new_request": "Create new request",
    "ai_create_text": "Generate text",
    "ai_apply_text": "Apply text",
    "ai_try_one_more": "Try again",
    "ai_correct_errors": "Correct mistakes",
    "ai_make_longer": "Extend",
    "ai_make_shorter": "Shorten",
    "ai_simplify": "Simplify",
    "ai_business_tone": "Formal",
    "ai_ceremonial_tone": "Festive",
    "ai_fun_tone": "Joyful",
    "ai_friendly_tone": "Friendly",
    "ai_change_tone": "Change tone of voice",
    "ai_improve_text": "Improve text",
    "ai_words_number": "Number of words:",
    "ai_translate": "Translate",
    "ai_translate_to_ru": "Translate to russian",
    "ai_translate_to_en": "Translate to english",
    "ai_add_creativity": "Add creativity",
    "ai_text_too_large": "Your text is too long to use AI. Make it shorter or generate a new text on the required topic with the help of AI.",
    "ai_translate_to_ua": "Translate to ukrainian",
    "ai_translate_to_es": "Translate to spanish",
    "ai_translate_to_pt": "Translate to portuguese",
    "ai_translate_to_tr": "Translate to turkish",
    "ai_translate_to_fr": "Translate to french",
    "ai_translate_to_de": "Translate to german",
    "ai_translate_to_it": "Translate to italian",
    "ai_translate_to_pl": "Translate to polish",
    "ai_free_request_error": "Free requests are over",
    "ai_free_request_number": "Request number: {{ FREE_KEY }} / {{ FREE_KEY_LIMIT }}",
    "ai_request_limit_info": "You can use up to 200 free AI tool requests. To make more requests, activate your API keys to the AI provider in your account settings.",
    "cancel": "Cancel",
    "gpt_error_quota": "You’ve reached your API request limit. To continue using AI tools, check your current limit or add funds to your credit balance in the OpenAI account settings.",
    "ai_generated_disclaimer": "You're responsible for the generated text. Review it before publishing."
}
